import { render } from "./SingleVersionItem.vue?vue&type=template&id=3d1b6710&scoped=true"
import script from "./SingleVersionItem.vue?vue&type=script&lang=js"
export * from "./SingleVersionItem.vue?vue&type=script&lang=js"

import "./SingleVersionItem.vue?vue&type=style&index=0&id=3d1b6710&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1b6710"]])

export default __exports__